import React, { Fragment } from 'react';
import { TextPlaceholder } from "../../../elements/TextPlaceholder";
import { Divider } from "../../../elements/Divider";
import { Dropdown } from "../../../inputs/Dropdown";
import { FlexContainer } from "../../../layout/FlexContainer";
import { Paragraph } from "../../../typography/Paragraph";
import { getStringWithColonSuffix } from "./getStringWithColonSuffix";
export var getRoomTypeDropdownMarkup = function getRoomTypeDropdownMarkup(isShowingPlaceholder, options, onChange, roomTypeInputLabel, roomTypesValue) {
  return isShowingPlaceholder ? React.createElement(Fragment, null, React.createElement(Divider, null), React.createElement(TextPlaceholder, {
    length: "medium"
  }), React.createElement(TextPlaceholder, {
    length: "medium"
  }), React.createElement(Divider, null)) : React.createElement(Fragment, null, React.createElement(FlexContainer, {
    alignItems: "center",
    flexWrap: "wrap"
  }, React.createElement(Paragraph, {
    weight: "heavy"
  }, getStringWithColonSuffix(roomTypeInputLabel)), React.createElement(Dropdown, {
    isClearable: false,
    onChange: onChange,
    options: options,
    value: roomTypesValue
  })), React.createElement(Divider, {
    size: "small"
  }));
};